import React from 'react'
import Spinner from '@/components/ui/spinner'
import { useFetchClientByCnpjCpf } from '@/features/client/services'
import { PageLayout } from '@/layouts'
import { useParams } from 'react-router-dom'
import DadosCliente from '@/features/client/components/dados-cliente'
import ClientInfo from '@/features/client/components/info-clientes'

const ClientsInfo: React.FC = () => {
  const params = useParams<{ cnpjcpf: string }>()
  const { data: clientData, isLoading } = useFetchClientByCnpjCpf(params.cnpjcpf)

  if (!clientData || isLoading) {
    return (
      <div className="w-full flex items-center justify-center h-screen">
        <Spinner size="large" />{' '}
      </div>
    )
  }

  return (
    <PageLayout
      description={
        <header>
          <div className="flex flex-col sm:flex-row items-center justify-between py-2">
            <div className="flex-1 sm:flex sm:justify-between sm:items-center">
              <div className="flex flex-row justify-center sm:justify-start space-x-2">
                <DadosCliente clientData={clientData} />
              </div>
            </div>
          </div>
        </header>
      }
    >
      <div className=" shadow overflow-hidden sm:rounded-lg ">
        <ClientInfo initialClientData={clientData} />
      </div>
    </PageLayout>
  )
}

export default ClientsInfo
